export enum ApiRoutes {
  IMPRESSION_VIEW = '/tracking/impression/view',
  IMPRESSION_CLICK = '/tracking/impression/click',
}
